import { DocumentRequirementKey } from "./globalTypes";

export interface PermitTypeDocumentTypeSettings {
  __typename: "DocumentTypeSettings";
  declaration: string;
  requirement: {
    __typename: "DocumentRequirement";
    key: DocumentRequirementKey;
    name: string;
  };
}

export interface PermitTypeDocumentTypeDocumentType {
  __typename: "DocumentType";
  id: string;
  name: string;
  key: string;
  settings: PermitTypeDocumentTypeSettings;
  isArchived: boolean;
}

export interface PermitTypeDocumentType {
  __typename: "PermitTypeDocumentType";
  id: string;
  documentType: PermitTypeDocumentTypeDocumentType;
  settings: PermitTypeDocumentTypeSettings | null;
}

/**
 * Returns the effective settings for a PermitTypeDocumentType.
 * If the permit-type-level override exists, use it; otherwise fall back to the document type's own settings.
 */
export function getEffectiveSettings(ptdt: PermitTypeDocumentType): PermitTypeDocumentTypeSettings {
  return ptdt.settings ?? ptdt.documentType.settings;
}
